export default __webpack_public_path__ + "static/media/arrow-left.4fff76ca.svg";